import { useNavigate } from 'react-router-dom';
import { AspectRatio, ButtonMantine, Grid, Group, ImageMantine, Stack, Text, Title } from 'ui';

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Grid>
      <Grid.Col span={{ base: 10, md: 4 }} offset={{ base: 1, md: 4 }}>
        <Stack gap={'lg'} align="center">
          <Group>
            <AspectRatio ratio={3 / 2}>
              <ImageMantine
                src="https://s3.us-east-1.amazonaws.com/com.givebacks.public/images/404.png"
                alt="Page Not Found"
                maw={238}
              />
            </AspectRatio>
          </Group>
          <Stack gap={'xs'}>
            <Title order={1} c="gray.6" ta="center">
              Page Not Found
            </Title>
            <Text fz={12} fw={400} c="gray.6" ta="center">
              We couldn&apos;t locate that page. <br />
              We suggest you go back to home.
            </Text>
          </Stack>
          <ButtonMantine onClick={() => navigate('/home')} fullWidth>
            Go to Home
          </ButtonMantine>
        </Stack>
      </Grid.Col>
    </Grid>
  );
};

export default PageNotFound;
